<template>
  <div v-if="item">
    <h5 v-if="item.system">Система: {{item.system.name}}</h5>
    <h5>MODEL: {{item.model_type}}</h5>
    <h5>ID: {{item.model_id}}</h5>
    <br />
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "system_keys",
    cardSetLink: "system_keys",
    item: null,
    fields: [
      {
        col: 'col-12',
        label: 'PARTNER ID',
        key: 'key',
        type: 'field'
      },

    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>

</style>
